import React from 'react';
import { Snackbar, Alert, Typography } from '@mui/material';
import { SnackbarSeverityEnum } from '../../enums/snackbar-severity-enum';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface SnackbarCustomProps {
  open: boolean;
  onClose: () => void;
  message: string;
  severity: SnackbarSeverityEnum;
  autoHideDuration?: number | null;
}

const SnackbarCustom: React.FC<SnackbarCustomProps> = ({
  open,
  onClose,
  message,
  severity,
  autoHideDuration = 6000,
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={{
            a: ({ href, children, ...props }) => {
              if (!href) return <>{children}</>;

              return (
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  {...props}
                  style={{ textDecoration: 'none' }}
                >
                  <Typography
                    variant="body3"
                    sx={theme => ({
                      color: theme.palette.primary.main,
                      fontWeight: 700,
                    })}
                  >
                    {children}
                  </Typography>
                </a>
              );
            },
          }}
        >
          {message}
        </ReactMarkdown>
      </Alert>
    </Snackbar>
  );
};

export default SnackbarCustom;
